var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Appbar'),_c('v-main',{staticClass:"ufv-main"},[_c('router-view')],1),_c('Footer'),_c('pwa-install-prompt')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }